// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.api = api;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'
import './assets/css/main.css'

 
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)

import HeaderEnt from './components/HeaderEnt'
Vue.component(HeaderEnt.name,HeaderEnt)

Vue.prototype.linkTo =  function (name, id) {
    router.push({name: name,params: {id}})
}
Vue.prototype.linkTo1 =  function (path) {
    router.push({path: path})
}

/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

import FooterEnt from './components/FooterEnt'
Vue.component(FooterEnt.name,FooterEnt)


/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js